// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__119_F","footer":"styles_footer__1ObRg"};